import { Controller } from 'react-hook-form';
import SelectAutocomplete from '../../inputs/select/autocomplete/select-autocomplete';
import { FormProps } from '../../../shared/interfaces/form';
import { useState, useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';

interface FormSelectProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
}

const FormSelect = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues
}: FormSelectProps) => {
  const [ isDisabledSelect, setIsDisabledSelect ] = useState(false);
  const [options, setOptions] = useState(item.options?.data || []);
  const watchedDependencyValue = useWatch({
    control,
    name: item.options?.dependsOnField || `__${item.name}_dependency__`,
  });
  const previousDependencyValueRef = useRef<any>(watchedDependencyValue);
  
  const handleSelectChange = (newValue: any, onChange: any) => {
    onChange(newValue);
    
    if (item.name === 'idTipoLancamento') {
    }
  };
  
  useEffect(() => {
    const page = window.location.hash.split('/')[1];

    if(page.toLocaleLowerCase().includes('list')) {
      setIsDisabledSelect(true);
    }

  }, [isDisabled]);

  useEffect(() => {
    setOptions(item.options?.data || []);
  }, [item.options?.data]);

  useEffect(() => {
    const dependencyFieldName = item.options?.dependsOnField;
    const loadOptions = item.options?.loadOptions;

    if (!dependencyFieldName || !loadOptions) {
      return;
    }

    if (!watchedDependencyValue) {
      setOptions([]);

      if (previousDependencyValueRef.current !== watchedDependencyValue) {
        setValue(item.name, item.options?.multiple ? [] : null);
      }

      previousDependencyValueRef.current = watchedDependencyValue;
      return;
    }

    if (
      previousDependencyValueRef.current &&
      previousDependencyValueRef.current !== watchedDependencyValue
    ) {
      setValue(item.name, item.options?.multiple ? [] : null);
    }

    previousDependencyValueRef.current = watchedDependencyValue;

    let isMounted = true;

    loadOptions(watchedDependencyValue)
      .then((loadedOptions) => {
        if (isMounted) {
          setOptions(loadedOptions || []);
        }
      })
      .catch(() => {
        if (isMounted) {
          setOptions([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [
    control,
    item.name,
    item.options?.dependsOnField,
    item.options?.loadOptions,
    item.options?.multiple,
    setValue,
    watchedDependencyValue,
  ]);


  return (
    <Controller
      key={`select-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue={item.value}
      rules={item.rules}
      render={({ field }) => (
        <div
          className={`form-input-wrapper ${item.fullWidth ? 'full-width' : ''}`}
          style={item.fullWidth ? { width: '100%', flexBasis: '100%' } : undefined}
        >
          <SelectAutocomplete
            placeholder={item.placeholder} 
            error={errors[item.name]?.message}
            data={options}
            value={field.value}
            width={item.width}
            height={item.height}
            onChange={(newValue) => handleSelectChange(newValue, field.onChange)}
            disabled={isDisabled || isDisabledSelect || !!(item.options?.dependsOnField && !watchedDependencyValue)}
            multiple={item.options?.multiple}
            actions={item.options?.actions}
          />
        </div>
      )}
    />
  );
};

export default FormSelect;
